import { EquipmentClient } from '@frontend/equipment/api';
import { IProduct } from '@frontend/product/types';
import { StockExtended } from '@frontend/stock/types';
import { useState } from 'react';

import { useScreen } from '../useScreen';

interface ViewProps {
    isProcessing: boolean;
    onSelect: (stock: StockExtended, product: IProduct) => void;
}

const useLendingReviewOverview = (): ViewProps => {
    const { updateWizardData, onSubmit } = useScreen();
    const [isProcessing, setIsProcessing] = useState(false);

    const onSelect = async (stock: StockExtended, product: IProduct) => {
        if (!stock.equipment?.entity_id) return;
        setIsProcessing(true);
        updateWizardData({ product, stock });
        await EquipmentClient.resolveEquipments([stock.equipment?.entity_id]).then((equipment) => {
            updateWizardData({ equipment: equipment.results[0] });
        });
        onSubmit();
        setIsProcessing(false);
    };

    return { isProcessing, onSelect };
};

export default useLendingReviewOverview;
